import React from 'react'
import { Link } from "react-router-dom";
import "./footersearch.scss";

const FooterSearch = () => {
  return (
    <div className="card text-center border-0">
      <div className="card-body">
        <p className="card-text">© 2024 Enth Inc. All rights reserved.</p>
      </div>
    </div>  
);
  
}

export default FooterSearch